module.exports = __webpack_public_path__ + "img/ai4.b0eb9011.png";